import { TitleSelectionValue } from '../component/title-selection-component.domain';
import {Address2ComponentValue} from '../component/address2-component.domain';
import {EntityTypeValue} from '../component/entity-type-component.domain';
import {BusinessNumberSearchValue} from '../component/business-number-search-component.domain';
import {GenderValue} from '../component/gender-component.domain';
import {PersonalAssetsValue} from '../component/personal-assets-component.domain';
import {PersonalLiabilitiesValue} from '../component/personal-liabilities-component.domain';
import {PropertyOwnerWithAddressValue} from '../component/property-owner-with-address-component.domain';
import {YesNoValue} from '../component/yes-no-component.domain';
import {CountryOfCitizenshipValue} from '../component/individual-form-component.domain';
import {IdentificationComponentValue} from '../component/identification-component.domain';
import {UploadFileValue} from '../component/file-upload-component.domain';
import {KybAddedParties, KybManualEntityValue, KybPersonRoleSelection} from '../kyb-key-people.domain';

import {Moment} from 'moment';

export type IndividualOrEntity = 'Individual' | 'Entity';
export type EntityGuarantor = {
  type: 'Entity',
  organisation: Exclude<BusinessNumberSearchValue, null>,
  organisationType: Exclude<EntityTypeValue, null>,
  abn: string,
  acn: string,
};
export type IndividualGuarantorWithoutAddress = {
  type: 'Individual',
  kind: 'WithoutPropertyAddress',
  title: TitleSelectionValue,
  firstName: string,
  lastName: string,
  middleName: string,
  // no longer collected by the unified individual-form; kept optional for historical values
  gender?: GenderValue,
  dob: Moment,
  hasAlias?: boolean,
  aliasNames?: string | null,
  countryOfCitizenship?: CountryOfCitizenshipValue,
  identification?: IdentificationComponentValue,
  idDocument?: UploadFileValue,
  residentialAddress: Address2ComponentValue,
  propertyOwner: YesNoValue,
  email: string,
  mobileNumber: string,
  personalAssets: PersonalAssetsValue,
  personalLiabilities: PersonalLiabilitiesValue,
};
export type IndividualGuarantorWithAddress = {
  type: 'Individual',
  kind: 'WithPropertyAddress',
  title: TitleSelectionValue,
  firstName: string,
  lastName: string,
  middleName: string,
  // no longer collected by the unified individual-form; kept optional for historical values
  gender?: GenderValue,
  dob: Moment,
  hasAlias?: boolean,
  aliasNames?: string | null,
  countryOfCitizenship?: CountryOfCitizenshipValue,
  identification?: IdentificationComponentValue,
  idDocument?: UploadFileValue,
  residentialAddress: Address2ComponentValue,
  propertyOwner: PropertyOwnerWithAddressValue,
  email: string,
  mobileNumber: string,
  personalAssets: PersonalAssetsValue,
  personalLiabilities: PersonalLiabilitiesValue,
};
export type IndividualGuarantor = IndividualGuarantorWithoutAddress | IndividualGuarantorWithAddress;
export type GuarantorValue = (IndividualGuarantor | EntityGuarantor)[] | null;

/**
 * Guarantor/signer ticks made against an additional guarantor entity's own key people. Carried
 * separately from `GuarantorValue` because they are persisted through the Key People write model
 * (stakeholder selections), not through the legacy guarantor payload.
 */
export interface GuarantorKybSelectionsEvent {
  selections: KybPersonRoleSelection[];
  selectedStakeholderIds: number[];
  manualEntities: KybManualEntityValue[];
  /**
   * Trustees/partners entered against a guarantor entity that is a trust or partnership. Such an
   * entity has no key people of its own, so these are what supply them - the same substitution the
   * applicant's own trust makes on the Key People step.
   */
  addedParties: KybAddedParties[];
}
